import React, { useEffect, useState } from 'react';
interface StickyButtonProps {
  targetRef: React.RefObject<HTMLElement>;
}
export const StickyButton: React.FC<StickyButtonProps> = ({
  targetRef
}) => {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (targetRef.current) {
        const rect = targetRef.current.getBoundingClientRect();
        // Show button when the target section has scrolled past the top of viewport
        setIsVisible(rect.top <= 0);
      }
    };
    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Check initial state
    return () => window.removeEventListener('scroll', handleScroll);
  }, [targetRef]);
  if (!isVisible) return null;
  return <div className="fixed bottom-0 left-0 right-0 z-50 p-4 bg-white border-t-2 border-gray-200 shadow-lg" data-id="element-480">
      <div className="max-w-3xl mx-auto" data-id="element-481">
        <a href="https://stresslessdogs.nl/liefdevol-communiceren" className="block w-full bg-green-600 hover:bg-green-700 text-white font-bold py-4 px-4 rounded-lg transition duration-200 text-center" target="_blank" rel="noopener noreferrer" data-id="element-482">
          Bekijk de Liefdevol Communiceren cursus
        </a>
      </div>
    </div>;
};